import { Component, inject, Input, OnInit } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DiagnosisDataEntry } from '../../models/workflow/diagnosis-entry';
import { ReviewInputInformationsStore } from './review-input-informations.store';

@Component({
    selector: 'app-review-input-informations',
    imports: [ProgressSpinnerModule],
    providers: [ReviewInputInformationsStore],
    templateUrl: './review-input-informations.component.html',
    styleUrl: './review-input-informations.component.scss'
})
export class ReviewInputInformationsComponent implements OnInit {
  readonly store = inject(ReviewInputInformationsStore);
  @Input() diagnosisSessionId: string = '';

  ngOnInit(): void {
    this.store.loadEnteredValues(this.diagnosisSessionId);
  }

  getEnteredValue(value: DiagnosisDataEntry) {
    return value.uoM
      ? `${value.inputValue} ${value.uoM.name}`
      : value.dataEntryValueName;
  }
}
